import React, { useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './NewDashboard.css';
import './AdminDashboard.css';
import ColegioService from '../services/ColegioService';
import { useAuth } from '../contexts/AuthContext';
import { hasOpenAIChatsEnabled, isFeatureEnabled } from '../utils/adminMenu';
import UserSessionMenu from './common/UserSessionMenu';
import AdminMenu from './common/menus/AdminMenu';
import ProfessorMenu from './common/menus/ProfessorMenu';
import AulaMensajesPanel from './common/AulaMensajesPanel';

const AulaMessages = () => {
  const navigate = useNavigate();
  const { aulaId } = useParams();
  const { user, logout } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const roleName = (user?.roleName || user?.nombreRol || user?.role || '').toLowerCase();
  const isAdmin = roleName.includes('admin');
  const featureFlags = useMemo(() => ColegioService.getFeatureFlags(), []);
  const hasOpenAIChats = useMemo(() => hasOpenAIChatsEnabled(featureFlags), [featureFlags]);
  const hasModuloAlumnos = useMemo(() => isFeatureEnabled(featureFlags, 'ModuloAlumnos'), [featureFlags]);
  const hasAgentesClasicos = useMemo(() => isFeatureEnabled(featureFlags, 'PermiteAgentesClasicosGPT'), [featureFlags]);

  const handleMenuNavigate = (item) => {
    setIsSidebarOpen(false);
    if (!item) return;

    if (isAdmin) {
      if (item.path) {
        navigate(item.path, item.state ? { state: item.state } : undefined);
        return;
      }
      if (item.id === 'agentes-clasicos-gpt') {
        navigate('/mis-agentes-clasicos-gpt');
        return;
      }

      navigate('/admin-dashboard', { state: { tab: item.id } });
      return;
    }

    if (item.path) {
      navigate(item.path, item.state ? { state: item.state } : undefined);
    }
  };

  const activeColegio = useMemo(() => ColegioService.getActiveColegio(), []);
  const activeColegioName = activeColegio?.nombre || activeColegio?.name || activeColegio?.descripcion || 'Colegio';

  return (
    <div className={`new-dashboard my-assistants ${isSidebarOpen ? 'sidebar-open' : ''}`}>
      {isSidebarOpen && <div className="sidebar-overlay" onClick={() => setIsSidebarOpen(false)} />}
      <aside className={`dashboard-sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <i className="fas fa-graduation-cap" />
            <span>aluxIA</span>
          </div>
        </div>

        {isAdmin ? (
          <AdminMenu
            activeId="aulas"
            user={user}
            featureFlags={featureFlags}
            onNavigate={handleMenuNavigate}
          />
        ) : (
          <ProfessorMenu
            activeId="aulas"
            hasOpenAIChats={hasOpenAIChats}
            hasAgentesClasicos={hasAgentesClasicos}
            hasModuloAlumnos={hasModuloAlumnos}
            onNavigate={handleMenuNavigate}
          />
        )}

        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="user-avatar">
              <i className="fas fa-user" />
            </div>
            <div className="user-info">
              <span className="user-name">{user?.displayName || user?.name || user?.email || 'Usuario'}</span>
              <span className="user-role">{isAdmin ? 'Administrador' : 'Profesor'}</span>
            </div>
          </div>
        </div>
      </aside>

      <main className="dashboard-main">
        <header className="dashboard-header">
          <div className="header-left">
            <button
              type="button"
              className="sidebar-toggle"
              onClick={() => setIsSidebarOpen((prev) => !prev)}
              title="Mostrar menú"
            >
              <i className="fas fa-bars" />
            </button>
            <h1 className="page-title">
              <i className="fas fa-comments" />
              Mensajes del aula
            </h1>
            <p className="page-subtitle">Colegio {activeColegioName}</p>
          </div>

          <div className="header-right">
            {!isAdmin && (
              <button className="btn btn-secondary" type="button" onClick={() => navigate('/my-aulas')}>
                <i className="fas fa-arrow-left" /> Volver a aulas
              </button>
            )}
            <UserSessionMenu
              user={user}
              onLogout={logout}
              extraItems={isAdmin ? [{ key: 'switch-school', label: 'Cambiar colegio', icon: 'fas fa-building', onClick: () => navigate('/admin/select-colegio') }] : []}
            />
          </div>
        </header>

        <div className="dashboard-content">
          <AulaMensajesPanel aulaId={aulaId} />
        </div>
      </main>
    </div>
  );
};

export default AulaMessages;
